export var LandingSections = {
    aboutUs: {
        id: 'about_us_section_id',
        text: 'О нас',
    },
    subscription: {
        id: 'subscription_section_id',
        text: 'Подписка',
    },
    contacts: {
        id: 'contacts_section_id',
        text: 'Контакты',
    },
    designing: {
        id: 'designing_section_id',
        text: 'Проектирование',
    },
};
